import React from 'react'
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import WorkIcon from './WorkIcon';
import SchoolIcon from './SchoolIcon';
import StarIcon from './StarIcon';

const Education = () => {
    return (
        <div>
            <div className="relative px-2 py-1 m-4 mx-auto md:mx-0 font-bold pt-[4%] text-2xl sm:text-3xl">
                <img className="w-full h-screen absolute object-cover opacity-20" src="assets/education-bg.jpg" alt="work-bg" />
                <div className="relative flex items-center justify-center">
                    <h1 className="text-white text-4xl items-center justify-center sm:text-4xl md:text-5xl lg:text-6xl pt-14 pb-6 sm:py-8 pl-2 font-bold text-center">
                        Education
                    </h1>
                </div>
            </div>
            <div className="px-2">
                <VerticalTimeline>
                    <VerticalTimelineElement
                        className="vertical-timeline-element--work"
                        contentStyle={{ background: 'transparent', boxShadow: 'none', padding: 0 }}
                        contentArrowStyle={{ borderRight: '7px solid rgb(255, 255, 255)' }}
                        date="Aug, 2014 - May, 2018"
                        iconStyle={{ background: 'rgb(0, 0, 0)', color: '#fff' }}
                        icon={<WorkIcon />}
                    >
                        <div className="skill-card w-full h-full flex flex-col transition-all duration-500 rounded-lg group relative hover:scale-[1.05] cursor-pointer">
                            <div className="h-full w-full rounded-lg border-2 border-[#1f223c] bg-[#11152c] border-b-4 border-b-[rgba(255,255,255,0.7)] shadow-none shadow-gray-50 group-hover:border-violet-500 transition-all duration-500">
                                <div className="flex -translate-y-[1px] justify-center">
                                    <div className="w-3/4">
                                        <div className="h-[1px] w-full bg-gradient-to-r from-transparent via-violet-500 to-transparent" />
                                    </div>
                                </div>
                                <div className="p-6">
                                    <h3 className="vertical-timeline-element-title text-xl sm:text-2xl md:text-3xl font-bold text-white">
                                        B.Tech, Computer Science & Engineering
                                    </h3>
                                    <h4 className="vertical-timeline-element-subtitle font-semibold text-[#AAA6C3] text-base sm:text-lg">Academy of Technology</h4>
                                    <h4 className="vertical-timeline-element-subtitle font-semibold text-[#AAA6C3] text-base sm:text-lg">Adisaptagram, West Bengal, India</h4>

                                    <ul className="mt-5 list-disc ml-5 space-y-2 text-left">
                                        <li className="text-base sm:text-lg">Graduated with 9.27 DGPA</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </VerticalTimelineElement>
                    <VerticalTimelineElement
                        className="vertical-timeline-element--work"
                        contentStyle={{ background: 'transparent', boxShadow: 'none', padding: 0 }}
                        contentArrowStyle={{ borderRight: '7px solid rgb(255, 255, 255)' }}
                        date="2011 - 2013"
                        iconStyle={{ background: 'rgb(0, 0, 0)', color: '#fff' }}
                        icon={<WorkIcon />}
                    >
                        <div className="skill-card w-full h-full flex flex-col transition-all duration-500 rounded-lg group relative hover:scale-[1.05] cursor-pointer">
                            <div className="h-full w-full rounded-lg border-2 border-[#1f223c] bg-[#11152c] border-b-4 border-b-[rgba(255,255,255,0.7)] shadow-none shadow-gray-50 group-hover:border-violet-500 transition-all duration-500">
                                <div className="flex -translate-y-[1px] justify-center">
                                    <div className="w-3/4">
                                        <div className="h-[1px] w-full bg-gradient-to-r from-transparent via-violet-500 to-transparent" />
                                    </div>
                                </div>
                                <div className="p-6">
                                    <h3 className="vertical-timeline-element-title text-xl sm:text-2xl md:text-3xl font-bold text-white">
                                        Higher Secondary Education, Science
                                    </h3>
                                    <h4 className="vertical-timeline-element-subtitle font-semibold text-[#AAA6C3] text-base sm:text-lg">Pingla Krishna Kamini Institution</h4>
                                    <h4 className="vertical-timeline-element-subtitle font-semibold text-[#AAA6C3] text-base sm:text-lg">Pingla, West Bengal, India</h4>

                                    <ul className="mt-5 list-disc ml-5 space-y-2 text-left">
                                        <li className="text-base sm:text-lg">Completed education with 80%.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </VerticalTimelineElement>
                </VerticalTimeline>
            </div>
        </div>
    )
}

export default Education;